import {Action, createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import axios from "axios";
import {useHistory} from "react-router-dom";

export interface UserState {
  isLoading: boolean;
  user: UserType;
  token: string;
  msg?: string;
}
export interface UserType {
  _id?: String;
  name: String;
  email: String;
  password?: String;
  role?: String;
  msg?: String;
}

const initialState: UserState = {
  isLoading: false,
  user: {
    name: "",
    email: "",
    role: "",
  },
  token: "",
  msg: "",
};

/*export const createNewUser = createAsyncThunk(
  "user/createNewUser",
  // Declare the type your function argument here:

  async (userObject: UserType) => {
    const headers = {
      "Content-Type": "application/json",
      "x-auth-token": `${localStorage.getItem("token")}`,
    };
    const response = await axios.post(
      "/api/users/",
      userObject,
      {headers: headers}
    );
    return (await response.data) as UserState
  }
);*/

export const createNewUser = createAsyncThunk(
  "user/createNewUser",
  async (userObject: UserType, { rejectWithValue }) => {
    const headers = {
      "Content-Type": "application/json",
      "x-auth-token": `${localStorage.getItem("token")}`,
    };
    try {
      const response = await axios.post(
        "/api/users",
        userObject,
        { headers: headers }
      );
      return (await response.data);
    } catch (err) {
      const error = err as any
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(error.response.data);
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearMsg: (state) => {
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNewUser.fulfilled, (state, action:PayloadAction<UserState>) => {
          state.isLoading = false;
          state.user = action.payload.user
          state.token = action.payload.token
        }
      )
      .addCase(createNewUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNewUser.rejected, (state, action) => {
        state.isLoading = false;
        const msg = action.payload as UserState;
        state.msg = msg.msg;
      })
  },
});
/*export const selectOffers = (state: RootState) => state.user.offers;*/
export default userSlice.reducer;
